import {
  FETCH_SETTINGS,
  FETCH_SETTINGS_SUCCESS,
  FETCH_SETTINGS_FAILED,
  EDIT_SETTINGS,
  CLEAR_SETTINGS_ERROR
} from "../store/types";

const DEFAULT_SETTINGS = {
  symbol: '€',
  code: 'EUR',
  decimal: 2,
  country: 'France',
  timezone: 'Europe/Paris',
  timeZone: 'Europe/Paris',
  business_timezone: 'Europe/Paris',
  business_country: 'France',
  swipe_symbol: false,
};

const INITIAL_STATE = {
  settings: DEFAULT_SETTINGS,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
};

export const settingsreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SETTINGS:
      return {
        ...state,
        loading: true
      };
    case FETCH_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: {
          ...DEFAULT_SETTINGS,
          ...(action.payload || {})
        },
        loading: false
      };
    case FETCH_SETTINGS_FAILED:
      return {
        ...state,
        settings: state.settings || DEFAULT_SETTINGS,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_SETTINGS:
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.payload
        }
      };
    case CLEAR_SETTINGS_ERROR:
      return {
        ...state,
        error: {
          flag: false,
          msg: null
        }
      };
    default:
      return state;
  }
};